import { render, staticRenderFns } from "./add-goods.vue?vue&type=template&id=7635947a&scoped=true&"
import script from "./add-goods.vue?vue&type=script&lang=js&"
export * from "./add-goods.vue?vue&type=script&lang=js&"
import style0 from "./add-goods.vue?vue&type=style&index=0&id=7635947a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7635947a",
  null
  
)

export default component.exports